export default {
  prototype: {
    defaultMsg: 'No content yet',
    defaultTitle: 'Tip',
    confirmButtonText: 'OK',
    cancelButtonText: 'Cancel',
  },
  separator: '. ',
};
